import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, onSnapshot } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    let q;
    if (filter === 'all') {
      q = query(collection(db, 'videos'), where('is_active', '==', true));
    } else {
      q = query(collection(db, 'videos'), where('is_active', '==', true), where('category', '==', filter));
    }
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const videosList = snapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      setVideos(videosList);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [filter]);

  // دالة استخراج معرف الفيديو من الرابط
  const getVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };

  const getCategoryName = (category) => {
    switch(category) {
      case 'beginner': return 'للمبتدئين';
      case 'analysis': return 'التحليل';
      case 'signals': return 'التوصيات';
      case 'advanced': return 'للمتقدمين';
      default: return 'عام';
    }
  };

  const getCategoryColor = (category) => {
    switch(category) {
      case 'beginner': return '#fef3c7';
      case 'analysis': return '#dcfce7';
      case 'signals': return '#dbeafe';
      default: return '#f0fdf4';
    }
  };

  const getCategoryTextColor = (category) => {
    switch(category) {
      case 'beginner': return '#92400e';
      case 'analysis': return '#166534';
      case 'signals': return '#1d4ed8';
      default: return '#065f46';
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading videos...</div>;
  }

  return (
    <div style={{ padding: '20px', direction: 'ltr', fontFamily: 'Arial' }}>
      <h1 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        📹 دروس فيديو TradeAH
      </h1>
      
      {/* فلاتر الفئات */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: '12px',
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => setFilter('all')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'all' ? '#1e40af' : '#e2e8f0',
            color: filter === 'all' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          الكل
        </button>
        <button
          onClick={() => setFilter('beginner')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'beginner' ? '#1e40af' : '#e2e8f0',
            color: filter === 'beginner' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          للمبتدئين
        </button>
        <button
          onClick={() => setFilter('analysis')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'analysis' ? '#1e40af' : '#e2e8f0',
            color: filter === 'analysis' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          التحليل
        </button>
        <button
          onClick={() => setFilter('signals')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'signals' ? '#1e40af' : '#e2e8f0',
            color: filter === 'signals' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          التوصيات
        </button>
        <button
          onClick={() => setFilter('advanced')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'advanced' ? '#1e40af' : '#e2e8f0',
            color: filter === 'advanced' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '20px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          للمتقدمين
        </button>
      </div>

      {/* عرض الفيديوهات */}
      {videos.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px', color: '#cbd5e1' }}>📹</div>
          <p>لا توجد فيديوهات حالياً</p>
        </div>
      ) : (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', 
          gap: '24px'
        }}>
          {videos.map(video => {
            const videoId = getVideoId(video.video_url);
            return (
              <div 
                key={video.id}
                style={{ 
                  backgroundColor: 'white',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  cursor: 'pointer'
                }}
                onClick={() => window.location.href = `/videos/${video.id}`}
              >
                {/* معاينة الفيديو */}
                {videoId ? (
                  <div style={{ position: 'relative', height: '200px' }}>
                    <img
                      src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                      alt={video.title}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover' 
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      backgroundColor: 'rgba(0,0,0,0.8)',
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}>
                      <div style={{
                        color: 'white',
                        fontSize: '24px',
                        marginLeft: '4px'
                      }}>
                        ▶
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ 
                    height: '200px', 
                    backgroundColor: '#f1f5f9',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#64748b'
                  }}>
                    معاينة غير متاحة
                  </div>
                )}
                
                {/* تفاصيل الفيديو */}
                <div style={{ padding: '16px' }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginBottom: '8px'
                  }}>
                    <span style={{ 
                      backgroundColor: getCategoryColor(video.category),
                      color: getCategoryTextColor(video.category),
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}>
                      {getCategoryName(video.category)}
                    </span>
                  </div>
                  
                  <h3 style={{ 
                    margin: '0 0 12px 0', 
                    color: '#0f172a', 
                    fontSize: '18px',
                    fontWeight: 'bold',
                    lineHeight: '1.4'
                  }}>
                    {video.title}
                  </h3>
                  
                  <p style={{ 
                    margin: 0, 
                    color: '#64748b', 
                    fontSize: '14px',
                    lineHeight: '1.6',
                    height: '60px',
                    overflow: 'hidden'
                  }}>
                    {video.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}